import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import './index.css'

// Self-hosted fonts (eliminates external Google Fonts dependency)
// Lato weights: 300 (light), 400 (regular), 700 (bold)
import '@fontsource/lato/300.css'
import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'
// Inter weights: 400 (regular), 500 (medium), 600 (semibold), 700 (bold)
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import { applyTheme } from './stores/themeStore'

// Apply theme immediately on page load (before React renders)
const savedTheme = localStorage.getItem('zupa-theme');
if (savedTheme) {
  try {
    const parsed = JSON.parse(savedTheme);
    if (parsed.state?.theme) {
      applyTheme(parsed.state.theme);
    }
  } catch {
    // Ignore parse errors
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
